import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Popconfirm, message} from 'antd';
import {SmallPopover, modal} from 'icsoc-antd-ex';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import TableBottomActions from 'Components/common/commonTable/tableBottomActions';
import IconFont from 'Components/common/iconFont';
import tWorkTimeActions from 'Actions/systemSetting/workTime';
import {getByteLen, cutStr} from 'Utils';
import sort from 'Utils/sort';
import moment from 'moment';

const {modalTips} = modal;
const columns = (pageStatus, handleAction,login) => [
  {
    title: '序号',
    key: 'key',
    dataIndex: 'key',
    width: 60,
    fixed: 'left',
    render: (text, record, index) => {
      const {pageNum, pageSize} = pageStatus;

      return sort({pageNum, pageSize, index});
    },
  },
  {
    title: '工作时间名称',
    dataIndex: 'workName',
    key: 'workName',
    width: '35%',
    render: text => text || '--',
  },
  {
    title: '最近修改时间',
    dataIndex: 'lastModifyTime',
    key: 'lastModifyTime',
    sorter: true,
    render: text =>
      (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
  },
  {
    title: '最近修改人',
    dataIndex: 'lastModifyName',
    key: 'lastModifyName',
    width: '25%',
    render: text =>
      text ? (
        <span title={text}>
          {getByteLen(text) > 24 ? `${cutStr(text, 24)}...` : text}
        </span>
      ) : (
        '--'
      ),
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    width: 80,
    fixed: 'right',
    render: (text, record) => (
      <div className="operate">
        {
          login.permissionsList.includes('systemSettingWorkTime.edit') ?
          <SmallPopover type="white" content="编辑" className="tooltip">
            <IconFont
              type="icon-robotedit"
              onClick={() => handleAction('edit', record.id)}
            />
          </SmallPopover>
        : null}
        {
          login.permissionsList.includes('systemSettingWorkTime.delete') ?
          <SmallPopover type="white" content="删除" className="tooltip">
            <Popconfirm
              placement="leftBottom"
              title="确认删除该工作时间吗？"
              onConfirm={() => {
                handleAction('confirmDelete', record.id);
              }}>
              <IconFont type="icon-robottrash" />
            </Popconfirm>
          </SmallPopover>
        : null}
        
      </div>
    ),
  },
];

class TableList extends UnionTableList {
  constructor(props) {
    super(props);

    this.state = {
      selectedRowKeys: [],
    };
  }

  // 列表选择
  onSelectChange = selectedRowKeys => {
    this.setState({selectedRowKeys});
  };

  // 批量删除
  batchDelete = () => {
    const {selectedRowKeys} = this.state;

    modalTips({
      centered: true,
      type: 'error',
      title: '提示',
      content: '确认批量删除工作时间吗？',
      onOk: () => this.confirmDelete(selectedRowKeys),
    });
  };

  handleAction = (type, id) => {
    this[type](id);
  };

  // 编辑工作时间
  edit = id => {
    const {setEditModalVisible, actions} = this.props;

    setEditModalVisible();
    actions.setEditModalData({id});
  };

  // 删除工作时间
  confirmDelete = (id = '') => {
    const {
      actions,
      setTableListLoading,
      getTableList,
      pageStatus: {pageNum, pageSize},
      tableListData: {total = 0} = {},
    } = this.props;
    const params = {
      ids: String(id).split(','),
    };

    setTableListLoading();
    actions
      .deleteWorkTime(params)
      .then(res => {
        const {payload: {code} = {}} = res || {};

        if (parseInt(code, 10) === 200) {
          message.success('删除成功！');
          this.setState({
            selectedRowKeys: [],
          });
          const {ids} = params;
          const newPageNum = Math.ceil((total - ids.length) / pageSize);
          const turnPageNum = pageNum < newPageNum ? pageNum : newPageNum || 1;

          this.setPageStatus({
            pageNum: turnPageNum,
          });
          getTableList({
            pageNum: turnPageNum,
            pageSize,
          });
        }
      })
      .finally(() => {
        setTableListLoading();
      });
  };

  render() {
    const {
      tableListData: {data = [], total = 0} = {},
      loading,
      pageStatus,
      login
    } = this.props;
    const {selectedRowKeys} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <CommonTable
        style={{marginTop: 20}}
        columns={columns(pageStatus, this.handleAction,login)}
        rowSelection={rowSelection}
        dataSource={[...data]}
        rowKey="id"
        loading={loading}
        extraHeight={20}
        scroll={{x: 1000}}
        onChange={this.handleTableChange}
        pagination={{
          current: pageStatus.pageNum,
          total: total && parseInt(total, 10),
          pageSize: pageStatus.pageSize,
          showTotal: () => (
            <TableBottomActions
              showTotalRender={`共 ${total} 条`}
              selects={login.permissionsList.includes('systemSettingWorkTime.batchDelete') ? selectedRowKeys.length :undefined }
              isMore={false}
              showButtons="2"
              contents={login.permissionsList.includes('systemSettingWorkTime.batchDelete') ? [{name: '批量删除', action: this.batchDelete}] :null}
            />
          ),
        }}
      />
    );
  }
}

const mapStateToProps = ({systemSettingWorkTime,login}) => ({
  tableListData: systemSettingWorkTime.tableListData,
  pageStatus: systemSettingWorkTime.pageStatus,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tWorkTimeActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
